import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import ExportReport from '@/views/keiei-joho/taishaku-taisho/TaishakuTaishoExportReport.vue'
import Setting from '@/views/keiei-joho/taishaku-taisho/TaishakuTaishoSettings.vue'

export const taishakuTaishoRoute: RouteRecordRaw = {
  path: '/keiei',
  component: BaseLayoutView,
  children: [
    {
      path: 'taishaku-taisho',
      children: [
        { path: 'export', component: ExportReport },
        { path: 'setting', component: Setting }
      ]
    }
  ]
}
